// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: "AIzaSyBiAOi8zS9CMQV83lVFi9jxo-rqEAEVvl8",
    authDomain: "smartbox-dev-4e288.firebaseapp.com",
    databaseURL: "https://smartbox-dev-4e288-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "smartbox-dev-4e288",
    storageBucket: "smartbox-dev-4e288.appspot.com",
    messagingSenderId: "732742893314",
    appId: "1:732742893314:web:2982600c7bef730cb74c1b",
    measurementId: "G-417ETG6FSC"
  },
  welcomeStorageBucket: 'smartbox-dev-welcome-screens'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
